import { AntProTableResponsiveTemplate } from "@finanedi.es/storybook"
import { UpdateActivoImpuestoEmpresaCommandProps } from "api/Commands/UpdateActivoImpuestoEmpresaCommand"
import { CuentaContableEmpresaReadingDtoProps } from "api/DTOs/CuentaContableEmpresaReadingDto"
import { GrupoImpuestoReadingDtoProps } from "api/DTOs/GrupoImpuestoReadingDto"
import { ImpuestoEmpresaReadingDtoProps } from "api/DTOs/ImpuestoEmpresaReadingDto"
import { activarImpuestoEmpresa } from "api/ImpuestoEmpresa.service"
import { TipoImpuestoEmpresaEnumType } from "api/Types/TipoImpuestoEmpresaEnum"
import { ToggleSwitch } from "common/components/Toogle"
import { TFunction } from "i18next"
import { TaxAccount } from "../components/TaxAccount"
import { TaxType } from "../components/TaxType"
import { TaxValue } from "../components/TaxValue"

const TAXES_COLUMNS_RESPONSIVE = (
  t: TFunction,
  record: ImpuestoEmpresaReadingDtoProps
) => {
  return [
    {
      label: t("impuestos.table.name"),
      value: record?.nombre ?? "",
    },
    {
      label: t("impuestos.table.value"),
      value: TaxValue(record),
    },
    {
      label: t("impuestos.table.scope"),
      value: TaxType({ type: record?.tipo, t }),
    },
    {
      label: t("impuestos.table.group"),
      value: record?.grupoImpuesto?.categoria ?? "",
    },
    {
      label: t("impuestos.table.account"),
      value: record?.cuentaContableEmpresa
        ? TaxAccount(record.cuentaContableEmpresa)
        : "",
    },
  ]
}

export const TAXES_COLUMNS = ({
  t,
  refetchTableData,
}: {
  t: TFunction
  refetchTableData(): void
}) => {
  const toggleHandler = ({
    id,
    activo,
  }: UpdateActivoImpuestoEmpresaCommandProps) =>
    activarImpuestoEmpresa({ id, activo }).then(() => refetchTableData())
  const columns = [
    {
      render: (record: ImpuestoEmpresaReadingDtoProps) => {
        return AntProTableResponsiveTemplate({
          title: "",
          columns: TAXES_COLUMNS_RESPONSIVE(t, record),
          headerStyles: "tw-pt-1 !tw-mt-2 !tw-pb-2",
        })
      },
      responsive: ["xs"],
      className: "tw-text-base tw-text-text",
    },
    {
      key: "Nombre",
      title: `${t("impuestos.table.name")}`,
      dataIndex: "nombre",
      responsive: ["sm"],
      className: "tw-text-base tw-text-text sm:!tw-pl-8 !tw-text-nowrap",
    },
    {
      key: "Valor",
      title: `${t("impuestos.table.value")}`,
      dataIndex: "valor",
      responsive: ["sm"],
      className: "tw-text-base tw-text-text !tw-text-nowrap",
      render: (_cell: number, rowData: ImpuestoEmpresaReadingDtoProps) =>
        TaxValue(rowData),
    },
    {
      key: "Tipo",
      title: `${t("impuestos.table.scope")}`,
      dataIndex: "tipo",
      responsive: ["sm"],
      className: "tw-text-base tw-text-text !tw-text-nowrap",
      render: (rowData: TipoImpuestoEmpresaEnumType) =>
        TaxType({ type: rowData, t }),
    },
    {
      key: "GrupoImpuesto",
      title: `${t("impuestos.table.group")}`,
      dataIndex: "grupoImpuesto",
      responsive: ["sm"],
      className: "tw-text-base tw-text-text",
      render: (cell: GrupoImpuestoReadingDtoProps) => cell?.categoria,
    },
    {
      key: "CuentaContableEmpresa",
      title: `${t("impuestos.table.account")}`,
      dataIndex: "cuentaContableEmpresa",
      responsive: ["sm"],
      className: "tw-text-base tw-text-text !tw-text-nowrap",
      render: (cell: CuentaContableEmpresaReadingDtoProps) => TaxAccount(cell),
    },
    {
      key: "esActivo",
      title: `${t("impuestos.table.active")}`,
      dataIndex: "esActivo",
      responsive: ["sm"],
      className: "tw-text-base tw-text-text",
      render: (cell: boolean, row: ImpuestoEmpresaReadingDtoProps) =>
        ToggleSwitch({
          defaultState: cell,
          isDisabled: row?.porDefecto,
          id: row?.id,
          onChangeHandler: (bool: boolean) =>
            toggleHandler({ id: row?.id ?? "", activo: bool }),
        }),
    },
  ]
  return columns
}
